import { useMemo } from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { uniqueId } from 'lodash';

import { GridFilterModel, GridLogicOperator } from '@sbv-clients/ui-shared';

import { employeesRowKey } from './employees-columns';
import { TabSelection } from './employees-stats-header';

export const isWeekendOperator: GridFilterOperator = {
  value: 'isWeekend',
  getApplyFilterFn: (filterItem, column) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (value) => {
      if (!value || !(value instanceof Date)) {
        return false;
      }
      return value.getDay() === 0 || value.getDay() === 6;
    };
  },
};

export function useAppliedFilter(tab: TabSelection, filterByWeekend: boolean) {
  return useMemo((): GridFilterModel => {
    const onBoarded = {
      field: employeesRowKey('isOnboarded'),
      operator: 'is',
      value: 'true',
      id: uniqueId(),
    };
    const registered = {
      field: employeesRowKey('isRegistered'),
      operator: 'is',
      value: 'true',
      id: uniqueId(),
    };
    const unregistered = {
      field: employeesRowKey('isRegistered'),
      operator: 'is',
      value: 'false',
      id: uniqueId(),
    };
    const mobile = {
      field: employeesRowKey('saasRole'),
      id: uniqueId(),
      operator: 'equals',
      value: 'Mobile',
    };
    const desktop = {
      field: employeesRowKey('saasRole'),
      id: uniqueId(),
      operator: 'isEmpty',
      value: null,
    };

    const weekend = {
      field: employeesRowKey('startDateTime'),
      operator: 'isWeekend',
      value: 'true',
      id: uniqueId(),
    };

    const items: GridFilterItem[] = [];

    if (filterByWeekend) {
      items.push(weekend);
    }

    switch (tab) {
      case TabSelection.all:
        break;
      case TabSelection.allOnboarded:
        items.push(onBoarded);
        break;
      case TabSelection.registered:
        items.push(registered);
        break;
      case TabSelection.registeredDesktop:
        items.push(registered, desktop);
        break;
      case TabSelection.registeredMobile:
        items.push(registered, mobile);
        break;
      case TabSelection.unregistered:
        items.push(unregistered);
        break;
      case TabSelection.unregisteredDesktop:
        items.push(unregistered, desktop);
        break;
      case TabSelection.unregisteredMobile:
        items.push(unregistered, mobile);
        break;
    }
    return {
      items,
      logicOperator: GridLogicOperator.And,
    };
  }, [filterByWeekend, tab]);
}
